import { Controller } from "@hotwired/stimulus"

// -/+ buttons around a native number input (.tj-stepper). The input keeps
// min/max/step; we just nudge the value and fire the events autosave listens for.
export default class extends Controller {
    static targets = ["input"]

    decrement() {
        this.step(-1)
    }

    increment() {
        this.step(1)
    }

    step(direction) {
        let input = this.inputTarget
        let step = parseFloat(input.step) || 1
        let current = parseFloat(input.value)
        if (Number.isNaN(current)) current = parseFloat(input.min) || 0
        let next = current + direction * step
        if (input.min !== "" && next < parseFloat(input.min)) next = parseFloat(input.min)
        if (input.max !== "" && next > parseFloat(input.max)) next = parseFloat(input.max)
        input.value = next
        input.dispatchEvent(new Event("input", { bubbles: true }))
        input.dispatchEvent(new Event("change", { bubbles: true }))
    }
}
